export default "__VITE_ASSET__Cok5Qifc__"